export default __webpack_public_path__ + "static/logotyp-785fced5cdbca91a2c7b3244386d652c.svg";